import { SimplePaymentPage } from 'modules/PaymentsApp/components/SimplePaymentPage'
import { IconExclamationTriangle } from '@sequencehq/core-components'

export const Unavailable = () => {
  return (
    <SimplePaymentPage
      icon={IconExclamationTriangle}
      iconColour="gray.70"
      header="Payment unavailable"
      subheader={
        'The payment process for this invoice is currently unavailable.'
      }
      nextSteps={[
        'Please contact the issuer to resolve this issue or change the current payment method.'
      ]}
    />
  )
}
